extractKeyPath